var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("手动录入"),
      visible: _vm.dialogVisible,
      width: 700
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 12
      },
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("财产保险累计收入（万元）"),
      prop: "property"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.dataFrom.property,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "property", $$v);
      },
      expression: "dataFrom.property"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("人身保险累计收入（万元）"),
      prop: "personal"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.dataFrom.personal,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "personal", $$v);
      },
      expression: "dataFrom.personal"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };